import { useMinerContext } from "@components/Pages/Machines/MinerRow/MinerContext";
import styles from "./MinerPhotos.module.scss";
import cn from "classnames";
import { EditOutlined, UploadOutlined } from "@ant-design/icons";
import MinerPhoto from "./MinerPhoto/MinerPhoto";
import { useDispatch } from "react-redux";
import { MODALS_ENUM } from "@constants/Modals";
import { show } from "redux-modal";
import { useIntl } from "react-intl";
import { MinerActions } from "@components/Pages/Machines/MinerRow/minerReducer";
import { useMe } from "@utils/hooks/useMe";
import { Flex } from "antd";
import Icon from "@components/global/new/Icon/Icon";
import upload from "@assets/redesign/icons/upload.svg";

export default function MinerPhotos() {
  const { formatMessage } = useIntl();
  const me = useMe();
  const { miner, dispatchMiner } = useMinerContext();
  const dispatch = useDispatch();

  const openUploadModal = () => {
    dispatch(
      show(MODALS_ENUM.UPLOAD_MINER_PHOTO_MODAL, {
        minerId: miner.id,
        photos: miner.photos || [],
        onSavePhotos,
      })
    );
  };
  const onSavePhotos = (p: string[]) => {
    dispatchMiner({
      type: MinerActions.Photos,
      payload: p,
    });
  };

  const hasPhoto = miner.photos && miner.photos.length > 0;

  return <Flex align="center" justify="space-between">
    <Flex align="center" gap={8}>
      {me?.is_admin && (<>
        <span className={styles.title}>
          {formatMessage({ id: "machines.more.photos.empty" })}
        </span>
        <Icon src={upload} onClick={openUploadModal} />
      </>)}
    </Flex>
    <Flex align="center" gap={20}>
      {miner.photos?.map((p, i, arr) => (
        <MinerPhoto src={p} images={arr} key={p} />
      ))}
    </Flex>
  </Flex>
}
